













































































































































import Vue, { PropType } from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import Receiver from "../../../../types/receivers/Receiver";
import { ValidationObserver } from "vee-validate";
import ReceiverAddress from "../../../../types/receivers/ReceiverAddress";
import { DefaultComputed, DefaultProps } from "vue/types/options";

type Methods = {
  validateAndUpdateReceiverAddress(): Promise<boolean>;
  emitAddressFormChangedEvent(): void;
};

export default Vue.extend<any, Methods, DefaultComputed, DefaultProps>({
  props: {
    receiver: {
      required: true,
      type: Object as PropType<Receiver>,
    },
  },
  components: {
    [Table.name]: Table,
    [Option.name]: Option,
    [Select.name]: Select,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      receiverAddress: {
        addressLine: this.receiver.address.addressLine,
        city: this.receiver.address.city,
        province: this.receiver.address.province,
        postcode: this.receiver.address.postcode,
      } as ReceiverAddress,
    };
  },
  created() {
    this.$watch(
      "receiver.address",
      (receiver: Receiver) => {
        this.receiverAddress.addressLine = receiver.address.addressLine;
        this.receiverAddress.city = receiver.address.city;
        this.receiverAddress.province = receiver.address.province;
        this.receiverAddress.postcode = receiver.address.postcode;
      },
      { immediate: true }
    );
  },
  methods: {
    emitAddressFormChangedEvent(): void {
      this.$emit("receiver-address-form-dirty");
    },
    async validateAndUpdateReceiverAddress(): Promise<boolean> {
      const validated = await (
        this.$refs.receiverAddress as InstanceType<typeof ValidationObserver>
      ).validate();

      if (!validated) {
        return false;
      }

      this.$emit("receiver-address-updated", this.receiverAddress);

      return true;
    },
  },
});
